import {
  ConfigState,
  LOAD_CONFIG,
  SET_LOCALE,
  SET_ORGANIZATION_CODE,
  SET_PAGE_TITLE,
  SET_TRANSLATION_DATE_FORMAT
} from './types';
import { get } from 'lodash';

export const config = (
  state: ConfigState = {},
  action: {
    type: string;
    payload?: ConfigState;
  }
): ConfigState => {
  switch (action.type) {
    case LOAD_CONFIG:
      return { ...state, ...action.payload, options: { ...state?.options, ...action?.payload?.options } };
    case SET_ORGANIZATION_CODE: {
      const payload = action.payload as Record<string, string>;
      const { organizationCode, translationSpace } = payload;
      return {
        ...state,
        options: {
          ...state.options,
          organizationCode,
          translationSpace
        }
      };
    }
    case SET_PAGE_TITLE: {
      return {
        ...state,
        pageTitle: get(action, 'payload.pageTitle')
      };
    }
    case SET_TRANSLATION_DATE_FORMAT: {
      const currentDateFormat = get(action.payload, 'currentDateFormat');
      const previousDateFormat = get(state, 'currentDateFormat');
      return { ...state, currentDateFormat, previousDateFormat };
    }
    case SET_LOCALE: {
      const locale = get(action, 'payload.locale');
      return { ...state, locale };
    }
    default:
      return state;
  }
};
